import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const data = {
  agentsLoadingStatus: false,
  agentsActive: null,
  agentsInvited: null,
  agentsInactive: null,
  agentDetails: null,
  clients: null,
  clientsActionRequired: null,
  clientDetails: null,
  allAgentsActive: null,
  routeToRedirect: '',
};

export default {
  state: data,
  getters,
  mutations,
  actions,
};
